<template>
  <template v-if="Array.isArray(store.state.user.user.roles) && store.state.user.user.roles.length">
    <table class="w-full border-collapse border">
      <tr
        v-for="role in store.state.user.user.roles"
        :key="role.id"
        @click="pushRoleCategoryList(role.slug)"
        class="hover:bg-mentalncSuperLight hover:shadow-md cursor-pointer"
      >
        <template v-if="!(role.slug === 'well_labo') && !(role.slug === 'welllabo_cancel')">
          <template v-if="is_yousei_group02">
            <template v-if="!(role.slug === 'yousei_online02') && !(role.slug === 'yousei_jitsugi02')">
              <th class="border border-slate-300 p-1 w-12 md:w-14">
                <img class="w-full" src="@/assets/images/header_logo.png" alt="LOGO">
              </th>
              <td class="border border-slate-300 px-4 font-semibold text-gray-700">{{ role.name }}</td>
            </template>
          </template>
          <template v-else>
            <th class="border border-slate-300 p-1 w-12 md:w-14">
              <img class="w-full" src="@/assets/images/header_logo.png" alt="LOGO">
            </th>
            <td class="border border-slate-300 px-4 font-semibold text-gray-700">{{ role.name }}</td>
          </template>
        </template>
      </tr>
    </table>
  </template>
  <template v-else>
    受講中の動画はありません。
  </template>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useStore } from '@/store/index'
import { useRouter } from 'vue-router'
import { RoleAttributes } from '@/types/models/role'

export default defineComponent({
  setup() {
    const store = useStore()
    const router = useRouter()
    const is_yousei_group02 = ref(false)

    const pushRoleCategoryList = (role_slug: string) => {
      router.push({ name: 'RoleCategoryList', params: { slug: role_slug } })
    }

    onMounted(() => {
      is_yousei_group02.value = store.state.user.user.roles.map((value: RoleAttributes) => value.slug).includes('yousei_group02')
    })

    return {
      store,
      pushRoleCategoryList,
      is_yousei_group02
    }
  }
})
</script>
